<app-nav></app-nav>

<router-outlet></router-outlet>

<app-footer></app-footer>

<div class="cookie-bar" *ngIf="showCookieBanner" role="dialog" aria-label="Preferenze cookie">
  <div class="cookie-inner container-xl">
    <div class="cookie-text">
      🍪 Utilizziamo cookie tecnici necessari al funzionamento del sito.
      Con il tuo consenso possiamo usare cookie di analisi e marketing.
      <a [routerLink]="['/privacy']">Scopri di più</a>.
    </div>

    <div class="cookie-actions">
      <button type="button" class="btn-sami-outline btn-sm" (click)="rejectCookies()">
        Rifiuta
      </button>
      <button type="button" class="btn-sami btn-sm" (click)="acceptCookies()">
        Accetta
      </button>
    </div>
  </div>
</div>
